import View from "../views/View";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type"; //For splitting words of description text

class homeView extends View {
  _aboutTitle = document.querySelector(".about__title");
  _quote = document.querySelector(".about__quote");
  _cvBtn = document.querySelector(".about__btn");
  _quoteP = document.querySelector(".about__quote-p");
  _heroImg = document.querySelector(".hero__pic");
  _projects = document.querySelector(".projects");
  _skillsContainer = document.querySelector(".skills");
  _scroller = gsap.registerPlugin(ScrollTrigger);

  //Hero section
  addHandlerInterceptHero() {
    const mm = gsap.matchMedia();

    //Desktop animation
    mm.add("(min-width : 950px)", () => {
      const maxY = document.querySelector(".about").offsetHeight + 100;

      const aboutRect = document
        .querySelector(".about")
        .getBoundingClientRect();

      const heroImgRect = this._heroImg.getBoundingClientRect();

      const targetX = aboutRect.left - heroImgRect.left;

      //Hero image on desktop
      gsap.to(this._heroImg, {
        y: maxY,
        x: targetX,
        opacity: 0.5,
        scrollTrigger: {
          trigger: document.querySelector(".about"),
          scrub: true,
          start: "top bottom",
          end: "top top",
        },
      });

      return () => {
        gsap.set(this._heroImg, { x: 0, y: 0, opacity: 1 });
        ScrollTrigger.refresh();
      };
    });

    //Mobile animation
    mm.add("(max-width : 950px)", () => {
      const setupHeroAnim = () => {
        const maxY = document.querySelector(".section__hero").offsetHeight;

        //Different opacity for themes for visibility
        let imgOpacity;
        const currentTheme =
          document.documentElement.getAttribute("data-theme");
        if (currentTheme === "light") {
          imgOpacity = 0.1;
        } else {
          imgOpacity = 0.3;
        }

        //Hero image on mobile
        gsap.to(this._heroImg, {
          y: maxY,
          opacity: imgOpacity,
          scrollTrigger: {
            trigger: this._heroImg,
            scrub: true,
            start: "top top",
          },
          onStart: () => {
            this._heroImg.style.filter = "brightness(2) ;";
          },
        });
      };

      //Wait for img to load then move it
      if (this._heroImg.complete) {
        setupHeroAnim();
      } else {
        this._heroImg.addEventListener("load", setupHeroAnim);
      }
    });
  }

  //About section
  addHandlerInterceptAbout() {
    const marginRight = 30; //3rem
    let targetX =
      window.innerWidth - this._aboutTitle.offsetWidth - marginRight;

    //About title animation
    gsap.to(this._aboutTitle, {
      x: targetX,
      duration: 2,
      scrollTrigger: {
        trigger: this._aboutTitle,
        start: "50% bottom",
        toggleActions: "restart none none reverse",
        scrub: true,
      },
    });

    //Splitting the text must wait for the webfont to finish loading
    const splitQuote = () => {
      const text = new SplitType(".about__quote-p", { types: "words" });

      gsap.from(text.words, {
        opacity: 0,

        y: 30,
        stagger: { amount: 2 },
        scrollTrigger: {
          trigger: ".about__quote-p",
          start: "50% bottom",
          end: "top 20%",
          scrub: true,
        },
      });
    };

    if (document.fonts && document.fonts.status !== "loaded") {
      document.fonts.ready.then(splitQuote);
    } else {
      splitQuote();
    }

    //About btn animation
    gsap.to(this._cvBtn, {
      duration: 2,
      scrollTrigger: {
        trigger: ".about__quote-p",
        start: "top center",
        toggleActions: "restart none none reverse",
        scrub: true,
        onEnter: () => {
          this._cvBtn.classList.remove("about__side-btn");
          this._cvBtn.classList.add("about__horizontal-btn");
        },
        onEnterBack: () => {
          this._cvBtn.classList.remove("about__side-btn");
          this._cvBtn.classList.add("about__horizontal-btn");
        },
        onLeave: () => {
          this._cvBtn.classList.add("about__side-btn");
          this._cvBtn.classList.remove("about__horizontal-btn");
        },
        onLeaveBack: () => {
          this._cvBtn.classList.add("about__side-btn");
          this._cvBtn.classList.remove("about__horizontal-btn");
        },
      },
    });
  }

  //Skills animations
  renderSkillsBar(skills) {
    const repeatedSkills = [...skills, ...skills];
    repeatedSkills.forEach((skill) => {
      this._skillsContainer.insertAdjacentHTML(
        "beforeend",
        `<h4 class="skills__element">${skill}</h4>`,
      );
    });
  }
}

export default new homeView();
